"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var play_api_1 = require("@l2p/play-api");
var prepareRewards = function (_a) {
    var rewards = _a.rewards;
    if (rewards) {
        return rewards.map(function (item, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return {
                cash: ((_a = item === null || item === void 0 ? void 0 : item.reward) === null || _a === void 0 ? void 0 : _a.type) === play_api_1.LotteryRewardType.Cash
                    ? "".concat((_c = Number(((_b = item.reward) === null || _b === void 0 ? void 0 : _b.amount) || 0)) === null || _c === void 0 ? void 0 : _c.toFixed(2), " ").concat((_d = item.reward) === null || _d === void 0 ? void 0 : _d.currency)
                    : null,
                freeSpins: ((_e = item === null || item === void 0 ? void 0 : item.reward) === null || _e === void 0 ? void 0 : _e.type) === play_api_1.LotteryRewardType.FreeRounds
                    ? (_g = (_f = item === null || item === void 0 ? void 0 : item.reward) === null || _f === void 0 ? void 0 : _f.bonus) === null || _g === void 0 ? void 0 : _g.title
                    : '',
                stuffReward: ((_h = item === null || item === void 0 ? void 0 : item.reward) === null || _h === void 0 ? void 0 : _h.type) === play_api_1.LotteryRewardType.Stuff
                    ? "".concat(item === null || item === void 0 ? void 0 : item.reward.stuffReward)
                    : 0,
                bonus: ((_j = item === null || item === void 0 ? void 0 : item.reward) === null || _j === void 0 ? void 0 : _j.type) === play_api_1.LotteryRewardType.Bonus
                    ? (_l = (_k = item === null || item === void 0 ? void 0 : item.reward) === null || _k === void 0 ? void 0 : _k.bonus) === null || _l === void 0 ? void 0 : _l.title
                    : null,
                username: item === null || item === void 0 ? void 0 : item.username,
                place: idx + 1,
                me: item === null || item === void 0 ? void 0 : item.me,
            };
        });
    }
    return [];
};
exports.default = prepareRewards;
